import Service from './index';

export default {
  cricketList() {
    return Service.get('/game/gameList?odds');
  },

  cricketFancyDetail(id, eventId) {
    return Service.get('/rates/RateList/' +id + '/' + eventId );
  },

  cricketgameDetail(id) {
    return Service.get('/game/gameList/' +id);
  },

  placeLevelBet(data) {
    return Service.post('/bet/LevelBetCreate', data);
  },

  placeBet(data) {
    return Service.post('/bet/Create', data);
  },

  eventList(id) {
    return Service.get('/event/EventList/'+id);
  },

  inplayGames() {
    return Service.get('/game/inplayGames');
  },

  gameListByGameType(gameType) {
    return Service.get('/game/gameListByGameType/' + gameType);
  },

  fairExchangeLogin() {
    return Service.post('/accountType/casinoFair')
  }

};
